<template>
    <v-container>
        <v-dialog v-model="dialog" max-width="1300px" persistent>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                color="primary"
                dark
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                v-if="canEdit"
                >เบิกสี</v-btn>
            </template>
            <v-card outlined>
                <v-card-title ><strong>เบิกสี</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div class="pl-5 pr-5">
                    <v-form ref="formDetail" lazy-validation>
                    <v-row >
                        <v-col>
                            <v-autocomplete
                                :rules="[rules.requiredConsumable]"
                                v-model="selectedConsumable"
                                return-object
                                :items="colors"
                                item-text="consumableDisplay"
                                item-value="consumableCode"
                                outlined 
                                autofocus
                                placeholder="พิมพ์รหัส หรือ ชื่อสี"
                                :disabled="isEditMode"
                                label="สี">
                            </v-autocomplete>
                        </v-col>
                         <v-col cols="3" v-if="isSelected">
                            <DatePicker 
                                ref="withdrawDate"
                                label="วันที่เบิก" 
                                @dateFormatted="setWithdrawDate" >
                            </DatePicker>
                        </v-col>
                        <v-col cols="2" v-if="isSelected"><v-text-field :rules="[rules.requiredNumber]" outlined placeholder=" "  label="จำนวน" maxlength="7" v-model="editedItem.qty"></v-text-field></v-col>
                    </v-row>

                    <div v-if="editedItem.colors && editedItem.colors.length > 0">
                        <v-row class="mx-2">
                            <v-col>
                                <v-divider class="ma-2"></v-divider>
                            </v-col>
                            <v-col cols="1"><v-btn color="primary" @click="dlgColor = true" small>เพิ่มสี</v-btn></v-col>
                        </v-row>
                        <v-row class="mx-2" v-for="color in editedItem.colors" :key="color.index">
                            <v-col ><v-text-field disabled outlined placeholder=" " label="สี" v-model="color.display"></v-text-field></v-col>
                            <v-col cols="2">
                                <v-text-field  outlined placeholder=" " :rules="[rules.requiredNumber, rules.requiredMaxNumber(color.stockRemain)]"
                                    label="ปริมาณผสมตามจำนวน (ml)" maxlength="7" v-model="color.qty"></v-text-field></v-col>
                            <v-col cols="2"><v-text-field  disabled outlined placeholder=" " label="ปริมาณผสม ต่อ 100 ml" maxlength="7" v-model="color.mainQtyDisplay"></v-text-field></v-col>
                            <v-col cols="2"><v-text-field  disabled outlined placeholder=" " label="สต๊อก" v-model="color.stockRemainDisplay"></v-text-field></v-col>
                    </v-row>
                    </div>
                    <v-row v-if="isSelected">
                        <v-col><v-text-field outlined placeholder=" " label="ช่างที่เบิก"  v-model="editedItem.withdrawBy"></v-text-field></v-col>
                    </v-row>
                    </v-form> 
                </div>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveDetail">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
           </v-dialog>

           <v-dialog v-model="dlgColor" max-width="500">
               <v-card outlined>
                   <v-card-title>เพิ่มสี</v-card-title>
                   <div class="pl-5 pr-5">
                    <v-form ref="formColor" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                :rules="[rules.requiredConsumable]"
                                v-model="selectedConsumableColor"
                                return-object
                                :items="consumableColors"
                                item-text="consumableDisplay"
                                item-value="consumableCode"
                                outlined 
                                placeholder="พิมพ์รหัส หรือ ชื่อสี"
                                label="สี">
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row class="mx-2">
                        <v-col ><v-text-field   outlined placeholder=" " label="ปริมาณผสม ต่อ 100 ml"
                        :rules="[rules.requiredMaxNumber(100)]"  maxlength="3" v-model="newColor.qty"></v-text-field></v-col>
                    </v-row>
                    </v-form>
                   </div>
                   <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="addColor">เพิ่ม</v-btn>
                    <v-btn color="primary" @click="closeDialogColor"> ยกเลิก</v-btn>
                </v-card-actions>
               </v-card>
           </v-dialog>
    </v-container>
</template>

<script>
import DatePicker from '@/components/Shared/DatePicker'
import rules from '@/assets/js/rules.js'
import {listDropdownConsumableColor, listDropdownConsumableType} from '@/api/common/dropdown-api.js'
import numeral from 'numeral'

export default {
    name: 'DlgWithDrawConsumableColor',
    components: {
        DatePicker
    },
    computed: {
        isSelected() {
            if (this.selectedConsumable == undefined) return false;
            return Object.entries(this.selectedConsumable).length > 0;
        },
        colors() {
            if (this.items.length == 0 || this.isEditMode) return this.colorList;
            let retColors = [];
            this.colorList.forEach(e => {
                retColors.push(e);
                
            });
            return retColors;
        }
    },
    watch: {
        dlgColor(val) {
            if (val) {
                this.newColor = Object.assign({}, {});
                this.newColor.qty = '';
            }
        },
        dialog(val) {
            if (!this.isEditMode && val) {
                this.loadColorList();
                this.loadConsumableColor();
            }
        },
        selectedConsumable(val) {
            if (!val || !this.isEditMode) {
                this.clearData();
            }
            if (this.isEditMode) return;
            this.editedItem.consumableCode = val.consumableCode;
            this.editedItem.consumableName = val.consumableName;
            this.editedItem.consumableType = val.consumableType;
            this.editedItem.consumableTypeText = val.consumableTypeText;
            this.editedItem.unitPrice = val.unitPrice;
            this.editedItem.unitOfSize = val.unitOfSize;
            this.editedItem.stockRemain = val.stockRemain;
            this.editedItem.colors = val.colorList;
        },
        selectedConsumableColor(val) {
            if (!val || !this.isEditMode) {
                this.clearDataColor();
            }
            if (this.isEditMode) return;
            this.newColor.consumableColorCode = val.consumableCode;
            this.newColor.consumableColorName = val.consumableName;
            this.newColor.consumableType = val.consumableType;
            this.newColor.display = val.consumableCode + ":" + val.consumableName;
            this.newColor.consumableTypeText = val.consumableTypeText;
            this.newColor.qty = val.qty;
            this.newColor.unitPrice = val.unitPrice;
            this.newColor.unitOfSize = val.unitOfSize;
            this.newColor.stockRemain = val.stockRemain;
            this.newColor.stockRemainDisplay = numeral(this.newColor.stockRemain).format('0,0');
            
        },
        "editedItem.qty" : function(newVal) {
            if (newVal == undefined) return;
            this.editedItem.colors.forEach(e => {
                e.qty = numeral(e.mainQty * (parseFloat(newVal) / 100)).format('0.00');
               // e.mainQtyDisplay = numeral(e.qty).format('0,0.00');
                e.stockRemainDisplay = numeral(e.stockRemain).format('0,0');
            });
        }
    },
    props: ["items", "canEdit", "branchCode"],
    data: () => ({
        dialog: false,
        dlgColor: false,
        rules: rules,
        colorMap: {},
        selectedConsumable: {},
        editedItem: {
            consumableCode: '',
            consumableName: '',
            consumableType: '',
            qty: 1,
            withdrawBy: '',
            withdrawDate: '',
            total: 0,
            stockRemain: 0,
            colors: []
        },
        colorList: [],
        isEditMode: false,
        consumableColors: [],
        selectedConsumableColor: {},
        newColor: {}
    }),
    methods: {
        clearDataColor() {
            this.newColor = Object.assign({}, {});
        },
        loadConsumableColor() {
            listDropdownConsumableType('C', this.branchCode, false).then(rs => {
                this.consumableColors = rs;
            });
        },
        loadColorList() {
            listDropdownConsumableColor(this.branchCode).then(rs => {
                this.colorList = rs;

                if (this.colorList == undefined || this.colorList.length == 0) return;
                this.colorList.forEach(e => {
                    if (e.colorList != undefined && e.colorList.length > 0) {
                        e.colorList.forEach((o, index) => {
                            o.index = index;
                            o.mainQty = o.qty;
                            o.mainQtyDisplay = numeral(o.qty).format('0,0.00');
                            o.stockRemainDisplay = numeral(o.stockRemain).format('0,0');
                        });
                    }
                });
            });
        },
        setWithdrawDate(val) {
            this.editedItem.withdrawDate = val;
        },
        clearData() {
            this.editedItem = Object.assign({}, {});
            this.editedItem.consumableCode = '';
            this.editedItem.colors = [];
        },
        closeDialogColor() {
            this.selectedConsumableColor = Object.assign({}, {});
            this.newColor = Object.assign({}, {});
            this.dlgColor = false;
        },
        addColor() {
            if (!this.$refs.formColor.validate()) {
                return;
            }
            this.newColor.mainQty = this.newColor.qty;
            this.newColor.mainQtyDisplay = numeral(this.newColor.qty).format('0,0.00');
            this.editedItem.colors.push(this.newColor);
            this.closeDialogColor();
        },
        closeDialog() {
            this.clearData();
            this.selectedConsumable = {};
            this.isEditMode = false;
            this.dialog = false;
            this.$emit("onCloseDialog");
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }
            this.$emit("onSaveConsumableColor", Object.assign({}, this.editedItem));
            this.closeDialog();
        },
        show(item) {
            this.isEditMode = true;
            if (item != undefined) {
                this.selectedConsumable = this.colorList.filter(e => e.consumableCode == item.consumableCode)[0];
                this.editedItem = Object.assign(this.editedItem, item);
                this.editedItem.colors = item.colors;
            }
            
            this.dialog = true;
        }
    }
}
</script>